<template>
    <div class="show-more" :class="{ expanded: expanded }">
        <div class="show-more-container" :style="'height: ' + height">
            <div class="show-more-content" ref="content">
                <slot></slot>
            </div>
        </div>
        <div class="container-button">
            <button
                v-if="! expanded && has_more"
                class="btn btn-text" 
                @click="showMore"
            >
            <!-- //btn-text -->
                {{ lang.labels.show_more }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        collapsedHeight: {
            type: Number,
            default: 190,
        },

        enabled: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            expanded: ! this.enabled,
            has_more: false,
        }
    },

    computed: {
        height() {
            return (this.expanded || ! this.has_more) ? 'auto' : (this.collapsedHeight + 'px')
        },

        lang() {
            return this.$root.lang.show_more
        },
    },

    mounted() {
        this.hasMore()
    },

    methods: {
        hasMore() {
            this.has_more = this.$refs.content.clientHeight > this.collapsedHeight
        },

        showMore() {
            this.expanded = true
        },
    },
}
</script>